import { useEffect, useState } from 'react';
import { supabase, hasSupabase } from './supabase';

// Subscribes to app_config.event_mode and returns [isPostEvent, setEventMode].
// setEventMode writes to the DB (admin only) and triggers realtime fan-out.
export function useEventMode(defaultPostEvent = false) {
  const [isPostEvent, setLocal] = useState(defaultPostEvent);

  useEffect(() => {
    if (!hasSupabase) return;
    let cancelled = false;

    supabase
      .from('app_config')
      .select('value')
      .eq('key', 'event_mode')
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled && data) setLocal(data.value === 'post_event');
      });

    const channel = supabase
      .channel('app_config:event_mode')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'app_config', filter: 'key=eq.event_mode' },
        (payload) => {
          const v = payload.new?.value ?? payload.old?.value;
          if (v) setLocal(v === 'post_event');
        },
      )
      .subscribe();

    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  const setEventMode = async (next) => {
    setLocal(next);
    if (hasSupabase) {
      await supabase
        .from('app_config')
        .upsert({ key: 'event_mode', value: next ? 'post_event' : 'live' });
    }
  };

  return [isPostEvent, setEventMode];
}
